<template>
	<div class="lock">
		<indexHeader></indexHeader>
		<div class="account-wrap">
			<div class="inback">
				<div>
					<span>{{$t('iesan.b_mangheli')}}</span>
				</div>
				<div class="text">{{$t('iesan.b_qingsong')}}</div>
				<img class="in" src="../../static/imgs/backimg.jpg">
			</div>
			<div class="comfirm-modal flex" v-show="show">
				<div class="comfirm-modal-content">
					<div class="loss-modal-header">
						<h3>{{$t('iesan.b_kaiqi')}}</h3>
						<p @click="close()">X</p>
					</div>
					<ul>
						<li>
							<p class="left">{{$t('iesan.b_xuyao')}} {{xiaohao}} USDT</p>
						</li>
						<li>
							<p class="right">{{$t('iesan.b_dangqian')}}：{{change_balance}}USDT</p>
						</li>
					</ul>
					<div class="modal-btn">
						<button type="button" @click="close()">{{$t('iesan.b_quxiao')}}</button>
						<button type="button" @click="com()">{{$t('iesan.b_ok')}}</button>
					</div>
				</div>
			</div>
			<div class="comfirm-modal flex" v-show="comfirmShow">
				<div class="comfirm-modal-content">
					<div class="loss-modal-header">
						<h3>USDT{{$t('iesan.b_cuocang')}}</h3>
						<p @click="closeMosal()">X</p>
					</div>
					<ul>
						<li class="flex">
							<p class="message">{{message}}</p>
						</li>
					</ul>
					<div class="modal-btn">
						<button type="button" @click="closeMosal()">{{$t('iesan.b_quxiao')}}</button>
						<button type="button" @click="comfirm()">{{$t('iesan.b_ok')}}</button>
					</div>
				</div>
			</div>
			<div class="account">
				<div class="order">
					<router-link to="/blindorder">{{$t('iesan.b_dindan')}}>></router-link>
				</div>
				<div class="accountcontent mineCardList">
					<div class="mineCard" @click="submit()" v-for="(item,index) in 6" :key="index">
						<img src="../../static/imgs/hongbao.png">
					</div>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
	import indexHeader from "@/view/indexHeader";
	export default {
		name: "noticeList",
		components: {
			indexHeader
		},
		data() {
			return {
				newList: [],
				comfirmShow: false,
				show: false,
				alterdata: {},
				listdata: [],
				page: 1,
				limit: 10,
				more: this.$t('iesan.b_genduo'),
				message: "",
				change_balance: "",
				xiaohao: "",
			};
		},
		filters: {
			toFixed8: function(value) {
				value = Number(value);
				return value.toFixed(8);
			},
			toFixed6: function(value) {
				value = Number(value);
				return value.toFixed(6);
			}
		},
		created() {
			var that = this;
		},
		mounted() {},
		methods: {
			close(){
				this.show = false;
			},
			com(){
				this.show = false;
				let _this = this;
				this.$http({
					url: '/api/blindbox/submit',
					method: 'post',
					data: {},
					headers: {
						'Authorization': localStorage.getItem('token')
					},
				}).then(res => {
					console.log(res.data)
					_this.message = res.data.message;
					_this.comfirmShow = true;
				});
			},
			closeMosal() {
				this.comfirmShow = false;
			},
			comfirm() {
				this.comfirmShow = false;
			},
			submit() {
				let _this = this;
				this.$http({
					url: '/api/blindbox/wallet',
					method: 'get',
					data: {},
					headers: {
						'Authorization': localStorage.getItem('token')
					},
				}).then(res => {
					console.log(res.data.message)
					_this.change_balance = res.data.message.change_balance;
					_this.xiaohao = res.data.message.xiaohao;
					_this.show = true;
				});
			},
		},
	};
</script>
<style lang="scss" scoped>
	.mt5 {
		margin: 10px 15px 0px;
	}

	.comfirm-modal {
		width: 100%;
		height: 100%;
		position: fixed;
		left: 0;
		top: 0;
		right: 0;
		bottom: 0;
		background-color: rgba(0, 0, 0, 0.7);
		justify-content: center;
		align-items: center;
		color: #c7cce6;
	}

	.comfirm-modal-content {
		width: 500px;
		background-color: #1a243b;
		margin: 0 auto;
		border-radius: 5px;
	}

	.loss-modal-header {
		line-height: 40px;
		text-align: center;
		position: relative;
	}

	.loss-modal-header p {
		position: absolute;
		right: 10px;
		top: 0;
	}

	.comfirm-modal-content li {
		line-height: 40px;
		width: 100%;
	}

	.comfirm-modal-content li .message {
		line-height: 130px;
		width: 100%;
		text-align: center;
		font-size: 25px;
		font-weight: bold;
	}

	.comfirm-modal-content li .left{
		text-align: left;
		padding-left: 40px;
		font-size: 26px;
		font-weight: bold;
		padding-top: 40px;
		padding-bottom: 20px;
	}
	.comfirm-modal-content li .right{
		text-align: right;
		padding-right: 20px;
	}

	.modal-btn {
		border-bottom-left-radius: 5px;
		border-bottom-right-radius: 5px;
		font-size: 0;
		padding-top: 30px;
	}

	.modal-btn button {
		width: 50%;
		line-height: 50px;
		border: none;
		float: left;
		font-size: 14px;
		color: #fff;
		background: #9db5c7;
	}

	.modal-btn button:last-child {
		border-left: 1px solid #2e333c;
		background: #689cf1;
	}

	.lock {
		.account-wrap {
			.inback {
				width: 100%;
				height: 230px;
				position: relative;
				box-sizing: border-box;
				padding-top: 60px;

				div {
					text-align: center;
					justify-content: center;
					position: relative;

					span {
						position: relative;
						background: #ffd12d;
						color: #000;
						font-weight: 700;
						padding: 5px 15px;
						border-radius: 15px;
						font-size: 14px;
					}
				}


				span:after {
					content: "";
					position: absolute;
					bottom: -8px;
					left: 18px;
					border-width: 0 10px 10px;
					border-style: solid;
					border-color: transparent transparent transparent #ffd12d;
				}

				.text {
					color: #FFFFFF;
					font-weight: 700;
					text-align: center;
					font-size: 30px;
					color: #fff;
					margin-top: 40px;
				}

				img {
					position: absolute;
					left: 0;
					top: 0;
					z-index: -1;
					width: 100%;
					height: 230px;
				}
			}

			.account {
				width: 1200px;
				margin: 40px auto;
				margin-bottom: 0;
				padding-top: 30px;
				overflow: hidden;
				padding-top: 0;
				.order{
					color: #FFFFFF;
					text-align: right;
					padding-bottom: 30px;
				}

				.accountcontent {
					width: 100%;
				}

				.mineCardList {
					color: #000;
					margin-right: 4%;
					display: flex;
					flex-direction: row;
					flex-wrap: wrap;

					.mineCard {
						border-radius: 15px;
						overflow: hidden;
						color: #000;
						width: 30%;
						margin-bottom: 40px;

						// margin-top: 20px;
						// flex: 1;
						// margin-right: 5%;
						// padding-top: 20px;
						// padding-bottom: 20px;
						img {
							width: 100%;
							height: 100%;
						}
					}

					.mineCard:nth-child(2) {
						margin: 0 5%;
						margin-bottom: 40px;
					}

					.mineCard:nth-child(5) {
						margin: 0 5%;
						margin-bottom: 40px;
					}
				}
			}
		}
	}
</style>



// WEBPACK FOOTER //
// src/view/blind.vue